import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { HOMEPAGE, LOGIN } from '../../../router/routes';
import GuestLayout from '../../../components/external/guest-layout';
import { useService } from '../../../services/services';
import authCss from '../auth-forms.module.css';
import Steps from './steps';
import { concatMap } from 'rxjs/operators';
import LatvijaLvUserData from '../../../interfaces/latvija-lv-user-data';
import Step1 from './step1';
import Step2 from './step2';
import Step3 from './step3';
import * as Sentry from '@sentry/react';

export interface UserData extends LatvijaLvUserData {
  email: string;
  email_confirmation: string;
  vat: boolean;
  sectors: { warehouse: boolean; crop: boolean; livestock: boolean };
  agree: boolean;
  agreeMarketing: boolean;
  phone: string;
  user_verified: boolean;
}

const userDataDefaults = {
  name: '',
  personal_code: '',
  farm_name: '',
  farm_registration_number: '',
  email: '',
  email_confirmation: '',
  vat: false,
  sectors: {
    warehouse: true,
    crop: false,
    livestock: false,
  },
  agree: false,
  agreeMarketing: false,
  phone: '',
  user_verified: false,
};

export default function Register() {
  const history = useHistory();
  const { authService, mailerLiteService } = useService();
  const [currentStep, setStep] = useState(1);
  const [userData, setUserData] = useState(userDataDefaults);

  useEffect(() => {
    const params = new URLSearchParams(history.location.search);
    if (params && params.get('step') === 'options') return;

    setStep(2);

    authService.latvijaLvUserData().subscribe(
      (latvijaLvData: LatvijaLvUserData) => {
        setUserData({ ...userDataDefaults, ...latvijaLvData });
      },
      (errorResponse) => {
        Sentry.captureException(errorResponse);
        history.push(HOMEPAGE);
      }
    );
  }, [history, authService]);

  const submitSecondStep = (data: any) => {
    setUserData({ ...userData, ...data });
    setStep(3);
  };

  const submitThirdStep = (data: UserData) => {
    if (data.agreeMarketing) {
      mailerLiteService.subscribe(data.email).subscribe(null, (error: any) => {
        Sentry.captureException(
          error?.response?.message || error?.message || error
        );
      });
    }

    const fullUserData = { ...userData, ...data };

    authService
      .csrf()
      .pipe(concatMap(() => authService.register(fullUserData)))
      .subscribe(() => {
        history.push(
          `${LOGIN}?registered=true&verified=${userData['user_verified']}`
        );
      });
  };

  return (
    <GuestLayout>
      <div className={authCss['container']}>
        <div className={authCss['form']}>
          <Steps currentStep={currentStep} />
          {currentStep === 1 && <Step1 />}
          {currentStep === 2 && (
            <Step2 userData={userData} onSubmit={submitSecondStep} />
          )}
          {currentStep === 3 && (
            <Step3 userData={userData} onSubmit={submitThirdStep} />
          )}
        </div>
      </div>
    </GuestLayout>
  );
}
